import React from 'react'
import ListNameContainer from './ListNameContainer'

const ListName = ({match, ...rest}) => (
  <ListNameContainer match={match} {...rest} />
)

export default ListName



// WEBPACK FOOTER //
// ./src/routes/Contacts/ListName/index.js